import { ILocation } from '../../types/global/helper';

export const types = {
    JOIN_PROGRAM: 'JOIN_PROGRAM',
    JOIN_PROGRAM_SUCCESS: 'JOIN_PROGRAM_SUCCESS',
    JOIN_PROGRAM_FAIL: 'JOIN_PROGRAM_FAIL',

    CREATE_OFFSITE_CAMPAIGN: 'CREATE_OFFSITE_CAMPAIGN',
    CREATE_OFFSITE_CAMPAIGN_SUCCESS: 'CREATE_OFFSITE_CAMPAIGN_SUCCESS',
    CREATE_OFFSITE_CAMPAIGN_FAIL: 'CREATE_OFFSITE_CAMPAIGN_FAIL',

    REQUEST_TO_JOIN_CAMPAIGN: 'REQUEST_TO_JOIN_CAMPAIGN',
    REQUEST_TO_JOIN_CAMPAIGN_SUCCESS: 'REQUEST_TO_JOIN_CAMPAIGN_SUCCESS',
    REQUEST_TO_JOIN_CAMPAIGN_FAIL: 'REQUEST_TO_JOIN_CAMPAIGN_FAIL',

    APPROVE_CAMPAIGN_JOIN_REQUEST: 'APPROVE_CAMPAIGN_JOIN_REQUEST',
    APPROVE_CAMPAIGN_JOIN_REQUEST_SUCCESS: 'APPROVE_CAMPAIGN_JOIN_REQUEST_SUCCESS',
    APPROVE_CAMPAIGN_JOIN_REQUEST_FAIL: 'APPROVE_CAMPAIGN_JOIN_REQUEST_FAIL',

    REJECT_CAMPAIGN_JOIN_REQUEST: 'REJECT_CAMPAIGN_JOIN_REQUEST',
    REJECT_CAMPAIGN_JOIN_REQUEST_SUCCESS: 'REJECT_CAMPAIGN_JOIN_REQUEST_SUCCESS',
    REJECT_CAMPAIGN_JOIN_REQUEST_FAIL: 'REJECT_CAMPAIGN_JOIN_REQUEST_FAIL',

    GET_OFFSITE_CAMPAIGN_DETAILS: 'GET_OFFSITE_CAMPAIGN_DETAILS',
    GET_OFFSITE_CAMPAIGN_DETAILS_SUCCESS: 'GET_OFFSITE_CAMPAIGN_DETAILS_SUCCESS',
    GET_OFFSITE_CAMPAIGN_DETAILS_FAIL: 'GET_OFFSITE_CAMPAIGN_DETAILS_FAIL',

    UPDATE_OFFSITE_CAMPAIGN: 'UPDATE_OFFSITE_CAMPAIGN',
    UPDATE_OFFSITE_CAMPAIGN_SUCCESS: 'UPDATE_OFFSITE_CAMPAIGN_SUCCESS',
    UPDATE_OFFSITE_CAMPAIGN_FAIL: 'UPDATE_OFFSITE_CAMPAIGN_FAIL',

    DELETE_OFFSITE_CAMPAIGN: 'DELETE_OFFSITE_CAMPAIGN',
    DELETE_OFFSITE_CAMPAIGN_SUCCESS: 'DELETE_OFFSITE_CAMPAIGN_SUCCESS',
    DELETE_OFFSITE_CAMPAIGN_FAIL: 'DELETE_OFFSITE_CAMPAIGN_FAIL',

    REQUEST_DELIEVERABLE_UPDATE: 'REQUEST_DELIEVERABLE_UPDATE',
    REQUEST_DELIEVERABLE_UPDATE_SUCCESS: 'REQUEST_DELIEVERABLE_UPDATE_SUCCESS',
    REQUEST_DELIEVERABLE_UPDATE_FAIL: 'REQUEST_DELIEVERABLE_UPDATE_FAIL',

    SEND_CAMPAIGN_MESSAGE: 'SEND_CAMPAIGN_MESSAGE',
    SEND_CAMPAIGN_MESSAGE_SUCCESS: 'SEND_CAMPAIGN_MESSAGE_SUCCESS',
    SEND_CAMPAIGN_MESSAGE_FAIL: 'SEND_CAMPAIGN_MESSAGE_FAIL',

    DELETE_CAMPAIGN_MESSAGE: 'DELETE_CAMPAIGN_MESSAGE',
    DELETE_CAMPAIGN_MESSAGE_SUCCESS: 'DELETE_CAMPAIGN_MESSAGE_SUCCESS',
    DELETE_CAMPAIGN_MESSAGE_FAIL: 'DELETE_CAMPAIGN_MESSAGE_FAIL',

    UPDATE_CAMPAIGN_MESSAGE: 'UPDATE_CAMPAIGN_MESSAGE',
    UPDATE_CAMPAIGN_MESSAGE_SUCCESS: 'UPDATE_CAMPAIGN_MESSAGE_SUCCESS',
    UPDATE_CAMPAIGN_MESSAGE_FAIL: 'UPDATE_CAMPAIGN_MESSAGE_FAIL',

    APPROVE_DELIVERABLE_SUBMISSION: 'APPROVE_DELIVERABLE_SUBMISSION',
    APPROVE_DELIVERABLE_SUBMISSION_SUCCESS: 'APPROVE_DELIVERABLE_SUBMISSION_SUCCESS',
    APPROVE_DELIVERABLE_SUBMISSION_FAIL: 'APPROVE_DELIVERABLE_SUBMISSION_FAIL',

    SCHEDULE_POST: 'SCHEDULE_POST',
    SCHEDULE_POST_SUCCESS: 'SCHEDULE_POST_SUCCESS',
    SCHEDULE_POST_FAIL: 'SCHEDULE_POST_FAIL',

    UPLOAD_DELIVERABLE: 'UPLOAD_DELIVERABLE',
    UPLOAD_DELIVERABLE_SUCCESS: 'UPLOAD_DELIVERABLE_SUCCESS',
    UPLOAD_DELIVERABLE_FAIL: 'UPLOAD_DELIVERABLE_FAIL',

    GET_CAMPAIGN_JOB_DETAILS: 'GET_CAMPAIGN_JOB_DETAILS',
    GET_CAMPAIGN_JOB_DETAILS_SUCCESS: 'GET_CAMPAIGN_JOB_DETAILS_SUCCESS',
    GET_CAMPAIGN_JOB_DETAILS_FAIL: 'GET_CAMPAIGN_JOB_DETAILS_FAIL',

    MANAGE_OFFSITE_CAMPAIGNS: 'MANAGE_OFFSITE_CAMPAIGNS',
    MANAGE_OFFSITE_CAMPAIGNS_SUCCESS: 'MANAGE_OFFSITE_CAMPAIGNS_SUCCESS',
    MANAGE_OFFSITE_CAMPAIGNS_FAIL: 'MANAGE_OFFSITE_CAMPAIGNS_FAIL',

    GET_BRANDS: 'GET_BRANDS',
    GET_BRANDS_SUCCESS: 'GET_BRANDS_SUCCESS',
    GET_BRANDS_FAIL: 'GET_BRANDS_FAIL',

    ADD_BRAND: 'ADD_BRAND',
    ADD_BRAND_SUCCESS: 'ADD_BRAND_SUCCESS',
    ADD_BRAND_FAIL: 'ADD_BRAND_FAIL',

    UPDATE_BRAND: 'UPDATE_BRAND',
    UPDATE_BRAND_SUCCESS: 'UPDATE_BRAND_SUCCESS',
    UPDATE_BRAND_FAIL: 'UPDATE_BRAND_FAIL',

    DELETE_BRAND: 'DELETE_BRAND',
    DELETE_BRAND_SUCCESS: 'DELETE_BRAND_SUCCESS',
    DELETE_BRAND_FAIL: 'DELETE_BRAND_FAIL',

    GET_BUZZBRIDGE_PROFILE: 'GET_BUZZBRIDGE_PROFILE',
    GET_BUZZBRIDGE_PROFILE_SUCCESS: 'GET_BUZZBRIDGE_PROFILE_SUCCESS',
    GET_BUZZBRIDGE_PROFILE_FAIL: 'GET_BUZZBRIDGE_PROFILE_FAIL',

    UPDATE_BUZZBRIDGE_PROFILE: 'UPDATE_BUZZBRIDGE_PROFILE',
    UPDATE_BUZZBRIDGE_PROFILE_SUCCESS: 'UPDATE_BUZZBRIDGE_PROFILE_SUCCESS',
    UPDATE_BUZZBRIDGE_PROFILE_FAIL: 'UPDATE_BUZZBRIDGE_PROFILE_FAIL',

    SEARCH_BRANDS: 'SEARCH_BRANDS',
    SEARCH_BRANDS_SUCCESS: 'SEARCH_BRANDS_SUCCESS',
    SEARCH_BRANDS_FAIL: 'SEARCH_BRANDS_FAIL',
};

type GroupType = 'active_jobs' | 'requests' | 'invitations';

export interface ISocialLinks {
    instagram?: string;
    tiktok?: string;
    youtube?: string;
    facebook?: string;
    twitter?: string;
    linkedin?: string;
    thspian?: string;
}

export type TIndustry =
    | 'Adult Entertainment'
    | 'Agriculture & Farming'
    | 'Animals & Wildlife'
    | 'Anime & Otaku Culture'
    | 'Art & Design'
    | 'Astrology & Horoscope'
    | 'Automotive'
    | 'Beauty & Personal Care'
    | 'Blogging & Vlogging'
    | 'Books & Publishing'
    | 'Business & Startups'
    | 'Cannabis & CBD'
    | 'Career & Job Search'
    | 'Celebrities & Gossip'
    | 'Charity & Activism'
    | 'Comics & Graphic Novels'
    | 'Conspiracy Theories'
    | 'Cooking & Recipes'
    | 'Crafts & DIY'
    | 'Cryptocurrency'
    | 'Culture & Society'
    | 'Dance'
    | 'Dating & Relationships'
    | 'Design & UX'
    | 'Education'
    | 'E-commerce'
    | 'Entertainment & Media'
    | 'Entrepreneurship'
    | 'Esports'
    | 'Events & Experiences'
    | 'Family & Parenting'
    | 'Fashion'
    | 'Finance & Banking'
    | 'Fitness & Sports'
    | 'Food & Beverage'
    | 'Gaming'
    | 'Gambling'
    | 'Gardening'
    | 'Health & Wellness'
    | 'History & Facts'
    | 'Hobbies & Interests'
    | 'Home & Living'
    | 'Humor & Memes'
    | 'Interior Design'
    | 'K-pop & J-pop'
    | 'Legal & Law'
    | 'Lifestyle'
    | 'Luxury Goods'
    | 'Marketing & Advertising'
    | "Men's Interests"
    | 'Mental Health'
    | 'Movies & TV'
    | 'Music & Nightlife'
    | 'Mythology & Folklore'
    | 'Nature & Outdoors'
    | 'News & Commentary'
    | 'Non-profit & Social Impact'
    | 'Parenting & Family'
    | 'Paranormal & Supernatural'
    | 'Pet Care'
    | 'Photography & Videography'
    | 'Politics & Commentary'
    | 'Professional Services'
    | 'Real Estate'
    | 'Religion & Faith'
    | 'Reviews & Unboxings'
    | 'Science & Innovation'
    | 'Self-Improvement'
    | 'Sexual Wellness'
    | 'Spirituality & Mindfulness'
    | 'Sustainability & Eco-Friendly'
    | 'Technology & Electronics'
    | 'Toys & Collectibles'
    | 'Travel & Hospitality'
    | 'True Crime'
    | 'Veganism & Plant-based Living'
    | 'Virtual Reality & Metaverse'
    | 'Weddings & Relationships'
    | 'Wellness Retreats & Healing'
    | "Women's Interests";

export interface IBrand {
    _id?: string;
    name: string;
    industry?: TIndustry;
    logo?: string;
    website?: string;
    description?: string;
    location?: ILocation;
    social_links?: ISocialLinks;
    verified?: boolean;
    created_by: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface ICreateBrand
    extends Pick<IBrand, 'name' | 'industry' | 'logo' | 'website' | 'description' | 'verified' | 'social_links'> {
    rawLogo?: File[];
}

export interface IGetBrands {
    searchTerm?: string;
}

/** The pagination below will work per group */
export interface IGetBuzzBridgeProfile {
    group_type?: GroupType; // 'active_jobs', 'requests', 'invitations', or undefined for all
    page?: number;
    limit?: number;
    skipRefresh?: boolean;
}

export interface ISearchBrand {
    searchTerm?: string;
}

export interface IJoinProgramPayload {}

export interface InfluencerProfile {
    username: string;
    followers: number;
    engagementRate: number;
    avg_likes: number;
    avg_comments: number;
    verified: boolean;
    profile_link: string;
    profile_picture: string;
    audience_demographics: AudienceDemographics;
    pricing: Pricing;
}

export interface AudienceDemographics {
    topCountries: CountryStat[];
    ageGroups: AgeGroupStat[];
    genderDistribution: GenderDistribution;
}

export interface CountryStat {
    country: string; // ISO Alpha-2 code, e.g. "NG", "GH"
    value: number; // number of followers from the country
}

export interface AgeGroupStat {
    group: string; // age group label, e.g. "18-24"
    value: number; // number of followers in the age group
}

export interface GenderDistribution {
    male: number;
    female: number;
    other: number;
}

export interface Pricing {
    post: string[]; // Could be string or number, depending on pricing model
    story: string[];
    reel: string[];
    video: string[];
    bundle: string[];
    igtv: string[];
}

export interface IPriceCard {
    post: [number];
    story: [number];
    reel: [number];
    video: [number];
    bundle: [number];
    igtv: [number];
    'live stream': [number];
    'sponsored post': [number];
    'product review': [number];
    'brand mention': [number];
    'event coverage': [number];
}

export interface IPlatformStats {
    username?: string;
    followers?: number;
    engagementRate?: number;
    avg_likes?: number;
    avg_comments?: number;
    verified?: boolean;
    profile_link?: string;
    profile_picture?: string;
    audience_demographics?: AudienceDemographics;
    pricing?: IPriceCard;
}

export interface ICategory {
    main: string;
    sub?: string;
}

export interface IDocument {
    name: string;
    format: string;
    url: string;
}

export interface IShippingAddress {
    addressLine1: string;
    addressLine2: string;
    country: string;
    zipcode?: string;
}

export interface IUnAvailabelDates {
    from: string;
    to: string;
    reason: string;
}

export interface IInfluencer {
    _id?: string;
    languages_spoken?: string[];
    categories?: ICategory[];
    profile_picture?: string;
    name?: string;
    date_of_birth?: string;
    country?: string;
    nationality?: string;
    bio?: string;

    instagram?: IPlatformStats;
    tiktok?: IPlatformStats;
    youtube?: IPlatformStats;
    facebook?: IPlatformStats;
    twitter?: IPlatformStats;
    thspian?: IPlatformStats;

    totalReach?: number;
    avg_engagement_rate?: number;
    avg_view_count?: number;
    total_content_pieces?: number;
    conversion_rate?: number;
    influencer_score?: number;
    niche_score?: number;
    ratings?: number;
    completed_campaigns?: number;

    preferred_collab_types?: string[];
    available_for_events?: boolean;
    available_for_long_term_collabs?: boolean;
    availability?: boolean;
    contracted_brands?: string[]; // ObjectId strings

    preferred_payment_method?: string;
    payment_account_details?: Record<string, any>;

    media_kit_link?: string;
    portfolio?: string[];
    documents?: IDocument[];
    past_collaborations?: string[]; // ObjectId strings

    location?: ILocation;
    shipping_address?: IShippingAddress;
    unavailable_dates?: IUnAvailabelDates;

    deleted?: boolean;
    verified_by_platform?: boolean;
    created_by: string; // User ObjectId string

    createdAt?: Date;
    updatedAt?: Date;

    past_collaborations_details: any[];
    contracted_brands_details: any[];
    calculatedReach: number;
    totalPosts: number;
    calculatedEngagement: number;
    active_jobs: any[];
    requests: any[];
    invitations: any[];
    active_jobs_count: number;
    requests_count: number;
    invitations_count: number;

    approved: boolean;
}

export interface IBuzzBridgeProfileResponse {
    status: string;
    pageSize: number;
    currentPage: number;
    data: Data;
    totalCount: TotalCount;
    totalPages: TotalPages;
    hasNextPage: HasNextPage;
    hasPreviousPage: HasPreviousPage;
    nextPage: NextPage;
    previousPage: PreviousPage;
    results: Results;
}

export interface Data {
    influencer: IInfluencer;
}

export interface Category {
    main: string;
}

export interface Instagram {
    username: string;
    followers: number;
    engagementRate: number;
    avg_likes: number;
    avg_comments: number;
    verified: boolean;
    profile_link: string;
    profile_picture: string;
    audience_demographics: AudienceDemographics;
    pricing: Pricing;
}

export interface AudienceDemographics {
    topCountries: TopCountry[];
    ageGroups: AgeGroup[];
    genderDistribution: GenderDistribution;
}

export interface TopCountry {
    country: string;
    value: number;
}

export interface AgeGroup {
    group: string;
    value: number;
}

export interface GenderDistribution {
    male: number;
    female: number;
    other: number;
}

export interface Tiktok {
    username: string;
    followers: number;
    engagementRate: number;
    avg_likes: number;
    avg_comments: number;
    verified: boolean;
    audience_demographics: AudienceDemographics2;
    pricing: Pricing2;
}

export interface AudienceDemographics2 {
    topCountries: any[];
    ageGroups: any[];
}

export interface Pricing2 {
    video: number[];
    post: any[];
    story: any[];
    reel: any[];
    bundle: any[];
    igtv: any[];
}

export interface Youtube {
    username: string;
    followers: number;
    engagementRate: number;
    avg_likes: number;
    avg_comments: number;
    verified: boolean;
    audience_demographics: AudienceDemographics3;
    pricing: Pricing3;
}

export interface AudienceDemographics3 {
    topCountries: any[];
    ageGroups: any[];
}

export interface Pricing3 {
    video: number[];
    post: any[];
    story: any[];
    reel: any[];
    bundle: any[];
    igtv: any[];
}

export interface Location {
    type: string;
    coordinates: number[];
    address: string;
}

export interface TotalCount {
    active_jobs: number;
    requests: number;
    invitations: number;
}

export interface TotalPages {
    active_jobs: number;
    requests: number;
    invitations: number;
}

export interface HasNextPage {
    active_jobs: boolean;
    requests: boolean;
    invitations: boolean;
}

export interface HasPreviousPage {
    active_jobs: boolean;
    requests: boolean;
    invitations: boolean;
}

export interface NextPage {
    active_jobs: any;
    requests: any;
    invitations: any;
}

export interface PreviousPage {
    active_jobs: any;
    requests: any;
    invitations: any;
}

export interface Results {
    active_jobs: number;
    requests: number;
    invitations: number;
}
